import styled from "styled-components";


const StyledSum = styled.div` 
    box-sizing: border-box;
    flex-wrap: wrap;
    justify-content: space-evenly;


.sum__justify{
    text-align: justify;
    margin-top: 30px;
    justify-content: center;

}
  
.sum__title{
    color: rgba(6, 214, 160, 1);
    text-align: center;
    margin-bottom: 10px;
    font-size: 50px;
    margin-top: 130px;
}

  
.sum__litle{
    color: rgba(17, 138, 178, 1);
    text-align: center;
    margin-bottom: 50px;
}

.sum__image{
        max-width: 90%;
        justify-content: right;
        margin-top: 70px;
}


/* Large Screen */
@media (min-width: 992px) {

.container{
        text-align: left;
        max-width: 1200px;
        margin: 0 auto;
        justify-content: space-around;
        flex-wrap: wrap;
        padding: 10px;
        margin: 30px auto;
        display: flex;
        margin-top: 10px;


}

.sum__title{
        color: rgba(6, 214, 160, 1);
        text-align: center;
        margin-bottom: 10px;
        font-size: 50px;
        margin-top: 130px;
}

.sum__litle{
        color: rgba(17, 138, 178, 1);
        text-align: center;
}


.sum__justify{
    text-align: justify;
    margin-top: 30px;
    justify-content: center;
}

.sum__image{
        max-width: 90%;
        justify-content: center;
        margin-top: 70px;
        margin-left: 18%;
}


.sum{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;  
}



}





`;

export default StyledSum;